import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
  featureName: string | null;
  onClose: () => void;
}

export const ComingSoonModal = ({ featureName, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={featureName !== null} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="smText">{t("Coming soon")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text color="smMuted">
            {t("{{feature}} is not available yet. We are working on it and will let you know once it is ready.", {
              feature: featureName ?? "",
            })}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            {t("Close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
